import React from 'react'
import { Row, Col } from 'react-flexbox-grid'

import styles from './Detail.module.css'

const Detail = ({ description, content }) => {
  return (
    <Row className={styles.row}>
      <Col xs={2} className={styles.description}>
        {description}
      </Col>
      <Col xs={10} className={styles.content}>
        {content}
      </Col>
    </Row>
  )
}

export default Detail



// WEBPACK FOOTER //
// ./src/components/shared/Detail.js